import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

import type { SimilarwebFieldsConfig } from "app/pages/sales-intelligence/common-components/export-table/types";

import { getAccountsSourceFieldsConfig, getScoringFieldsConfig } from "./accountsFields";
import { getRequesterFieldsConfig } from "./requesterFields";
import { getSubsidiaryFieldsConfig } from "./subsidiaryFields";

export const getContactsSourceFieldsConfig = (): SimilarwebFieldsConfig =>
    Object.seal({
        ["company_name"]: {
            name: "Company name",
            example: "ACME Corp",
            field: "company_name",
            valueType: "Text",
        },
        site: {
            name: "Website",
            example: "acme-labs.com",
            field: "site",
            valueType: "Text",
        },
        ["email"]: {
            name: "Email",
            example: "john.smith@acme-labs.com",
            field: "email",
            valueType: "Text",
        },
        ["first_name"]: {
            name: "First Name",
            example: "John",
            field: "first_name",
            valueType: "Text",
        },
        ["last_name"]: {
            name: "Last Name",
            example: "Smith",
            field: "last_name",
            valueType: "Text",
        },
        ["job_title"]: {
            name: "Title",
            example: "Sales Director, Europe",
            field: "job_title",
            valueType: "Text",
        },
        ["department"]: {
            name: "Department",
            example: "SALES, OVERSIGHT",
            field: "department",
            valueType: "Text",
        },
        ["seniority"]: {
            name: "Seniority",
            example: "Senior Leadership",
            field: "seniority",
            valueType: "Text",
        },
        ["role"]: {
            name: "Role",
            example: "Director",
            field: "role",
            valueType: "Text",
        },
        ["country"]: {
            name: "Country",
            example: "United States",
            field: "country",
            valueType: "Text",
        },
        ["country_code"]: {
            name: "Country Code",
            example: "US",
            field: "country_code",
            valueType: "Text",
        },
        ["direct_phone"]: {
            name: "Direct Phone",
            example: "16462222222",
            field: "direct_phone",
            valueType: "Text",
        },
        ["mobile_phone"]: {
            name: "Mobile Phone",
            example: "16461111111",
            field: "mobile_phone",
            valueType: "Text",
        },
        ["contact_linkedin_url"]: {
            name: "LinkedIn URL",
            example: "https://www.linkedin.com/in/john-smith",
            field: "contact_linkedin_url",
            valueType: "Text",
        },
        ["revealed_by"]: {
            name: "Revealed By",
            example: "Jane Doe",
            field: "revealed_by",
            valueType: "Text",
        },
        ["revealed_date"]: {
            name: "Revealed Date",
            example: "01/01/2022",
            field: "revealed_date",
            valueType: "Date",
        },
    });

export const getContactsFields = (integrationName: Integration): Readonly<SimilarwebFieldsConfig> => {
    if (integrationName === "salesforce" || integrationName === "dynamics") {
        return Object.seal({
            ...getContactsSourceFieldsConfig(),
            ...getScoringFieldsConfig(),
            ...getRequesterFieldsConfig(),
        });
    }

    return Object.seal({
        ...getContactsSourceFieldsConfig(),
        ...getAccountsSourceFieldsConfig(),
        ...getRequesterFieldsConfig(),
        ...getSubsidiaryFieldsConfig(),
    });
};
